import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { JpgOrPngConversionResponse } from '../../../../../../../shared/models/JpgOrPngConversionResponse';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { ConversionService } from '../../../../../../../shared/services/conversion.service';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { AiImageGenerationModel } from '../../models/ai-image-generation';
import { ImageResolutionModel, IMAGE_RESOLUTIONS } from '../../models/image-resolution';
import { AiService } from '../../services/ai.service';
import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { BackgroundRemovalModel } from '../../models/background-remover';
import { NgForm } from '@angular/forms';
import { ImageCaptionGeneratorRequestModel, ImageCaptionGeneratorResponseModel } from '../../models/caption-generator';
import { ClipboardService } from 'ngx-clipboard';


@Component({
  selector: 'app-caption-generator',
    standalone:false,

  templateUrl: './caption-generator.component.html',
  styleUrl: './caption-generator.component.css'
})

export class CaptionGeneratorComponent implements OnInit {

  fileError: string | null = null;
  isFileSelected!: boolean;
  allowedExtensions: string[] = ['jpg', 'png','jpeg'];
  imageCaptionGeneratorRequestModel: ImageCaptionGeneratorRequestModel = new ImageCaptionGeneratorRequestModel();
  imageCaptionGeneratorResponseModel: ImageCaptionGeneratorResponseModel = new ImageCaptionGeneratorResponseModel();
  isCopied:boolean= false;
  isLoading:boolean = false;
  @ViewChild('captionGeneratorForm') captionGeneratorForm!: NgForm;
  captionAiSubscription!:Subscription;

  constructor(
    private aiService: AiService,
    private alertService:AlertService,
    private clipboardService: ClipboardService,
    private cdr:ChangeDetectorRef) {}

 async ngOnInit() {
  this.preventBrowserDefaults();

  }


  onSelect(event: Event): void {
    this.fileError = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024*1024);
      if(fileSizeMB > 10){
        this.clear();
        this.fileError = 'File size exceeds 10MB. Please select a smaller file.';
        return;
      }
      if (fileExtension && this.allowedExtensions.includes(fileExtension)) {
        this.imageCaptionGeneratorResponseModel.caption='';
        this.handleFileSelection(file);
      } else {
        this.imageCaptionGeneratorRequestModel.image = null;
        this.captionGeneratorForm.resetForm(this.imageCaptionGeneratorRequestModel);
        this.isFileSelected = true;
        this.fileError = `Invalid file type.Please select a valid file (${this.allowedExtensions.join(
          ','
        )}).`;
      }
    }
  }
  handleFileSelection(file: File): void {

    if (file) {
      this.imageCaptionGeneratorRequestModel.image = file;
      this.isFileSelected = true;
      this.generateImageCaption();

    } else {
      this.imageCaptionGeneratorRequestModel.image = null;
      this.isFileSelected = true;
    }
  }

  get isValidFile(): boolean {

    if (!this.imageCaptionGeneratorRequestModel.image) {
      return false;
    }
    const fileName =
      this.imageCaptionGeneratorRequestModel.image.name.toLowerCase();
    return fileName.endsWith(ImageFormat.Png.toString().toLowerCase()) || fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase()) || fileName.endsWith(ImageFormat.Jpeg.toString().toLowerCase());
  }


  clearFile(fileInput: HTMLInputElement): void {
    fileInput.value = '';
    this.imageCaptionGeneratorRequestModel.image = null;
    this.isFileSelected = false;
    this.fileError = null;
    this.isLoading = false;

  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.fileError = null;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fakeInputEvent = {
        target: { files: [file] }
      } as unknown as Event;
      this.onSelect(fakeInputEvent);
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  preventBrowserDefaults() {
    ['dragover', 'drop'].forEach(eventName => {
      window.addEventListener(eventName, (e) => {
        e.preventDefault();
      }, false);
    });
  }

  clear():void{
    this.imageCaptionGeneratorRequestModel.image = null;
    this.isFileSelected = false;
    this.fileError = null;
    this.isLoading = false;
    this.captionGeneratorForm.resetForm();
    this.imageCaptionGeneratorResponseModel.caption = '';
    this.isCopied= false;
    if(this.captionAiSubscription){
      this.captionAiSubscription.unsubscribe();
    }
    this.cdr.detectChanges();
  }

  async regenerateImageCaption(){
    this.imageCaptionGeneratorResponseModel.caption = '';
    await this.generateImageCaption();
  }

  async generateImageCaption(){
    this.isLoading = true;
    this.fileError = null;
    this.captionAiSubscription= await this.aiService
      .generateImageCaption(this.imageCaptionGeneratorRequestModel)
      .subscribe({
        next: (data:ImageCaptionGeneratorResponseModel) => {
          this.imageCaptionGeneratorResponseModel.caption = data.caption;
          this.isLoading=false;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        },
        error: (err) => {
          this.isLoading=false;
          this.fileError = err?.error?.errors?.[0].message || err?.error?.errors?.[0].errors?.[0];
        },
      });

  }

  copyCaption(): void {
    this.isCopied = true;
    this.clipboardService.copyFromContent(this.imageCaptionGeneratorResponseModel.caption);
      setTimeout(() => {
        this.isCopied = false;
      }, 500);
  }

  get getIcon():string {
    return this.isCopied ? '../../../../../../../assets/theme/images/icons/copy-check.svg'
    : '../../../../../../../assets/theme/images/icons/copy.svg';
  }

  getToolTipTitle():string{
    return this.isCopied ? 'Copied' : 'Copy Caption';
  }

  ngOnDestroy(): void {
    if(this.captionAiSubscription){
      this.captionAiSubscription.unsubscribe();
    }
  }

}
